module.exports = __webpack_public_path__ + "img/web.9402051f.png";